var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQldDots = function SvgQldDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 249,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M162.23 235.03c5.274 0 9.55-4.276 9.55-9.55s-4.276-9.55-9.55-9.55-9.55 4.276-9.55 9.55 4.276 9.55 9.55 9.55M10.39 19.19a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M145.52 214.47c5.274 0 9.55-4.276 9.55-9.55s-4.276-9.55-9.55-9.55-9.55 4.276-9.55 9.55 4.276 9.55 9.55 9.55M131.26 248.81c5.274 0 9.55-4.276 9.55-9.55s-4.276-9.55-9.55-9.55-9.55 4.276-9.55 9.55 4.276 9.55 9.55 9.55"
  })));
};
export default SvgQldDots;